// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   RiCalendarLine,
//   RiRefreshLine,
//   RiTeamLine,
//   RiArrowLeftSLine,
//   RiArrowRightSLine,
//   RiErrorWarningLine,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";

// const ATTENDANCE_URL = `${process.env.REACT_APP_API_URL}/attendance`;

// const currentYear = () => new Date().getFullYear();
// const currentMonth = () => new Date().getMonth() + 1;

// const MONTH_NAMES = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];

// // ✅ "completed" = approved + checked-out = Present
// // "partial"   = approved but still checked-in = also Present (approved = present)
// // "absent"    = no approved entry
// const STATUS_SQUARE = {
//   completed: "bg-emerald-500",
//   partial: "bg-emerald-400", // approved = present, slightly lighter to distinguish
//   absent: "bg-red-400",
// };

// const percentColor = (pct) => {
//   const n = parseFloat(pct);
//   if (n >= 85) return "text-emerald-600 border-emerald-400 bg-emerald-50";
//   if (n >= 60) return "text-amber-600 border-amber-400 bg-amber-50";
//   return "text-red-500 border-red-400 bg-red-50";
// };

// export default function AllAttendance() {
//   const [year, setYear] = useState(currentYear());
//   const [month, setMonth] = useState(currentMonth());
//   const [metadata, setMetadata] = useState(null);
//   const [staffAttendance, setStaffAttendance] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const isCurrentMonth = year === currentYear() && month === currentMonth();

//   const fetchMonthly = async (y, m) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await axios.get(
//         `${ATTENDANCE_URL}/monthly-attendance/${y}/${m}`,
//       );
//       const data = res.data;
//       setMetadata(data.metadata || null);
//       setStaffAttendance(data.staffAttendance || []);
//     } catch {
//       setError("Failed to fetch monthly attendance.");
//       setStaffAttendance([]);
//       setMetadata(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchMonthly(year, month);
//   }, [year, month]);

//   const prevMonth = () => {
//     if (month === 1) {
//       setYear((y) => y - 1);
//       setMonth(12);
//     } else setMonth((m) => m - 1);
//   };

//   const nextMonth = () => {
//     const now = new Date();
//     if (
//       year > now.getFullYear() ||
//       (year === now.getFullYear() && month >= now.getMonth() + 1)
//     )
//       return;
//     if (month === 12) {
//       setYear((y) => y + 1);
//       setMonth(1);
//     } else setMonth((m) => m + 1);
//   };

//   const totalDays = metadata?.totalDays || new Date(year, month, 0).getDate();
//   const dayNumbers = Array.from({ length: totalDays }, (_, i) => i + 1);

//   return (
//     <div className="min-h-screen bg-white text-slate-800">
//       <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
//               <RiCalendarLine className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-blue-800 tracking-tight">
//                 Monthly Attendance
//               </h1>
//               <p className="text-[11px] text-blue-400 tracking-widest uppercase">
//                 Staff Attendance Overview
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-3">
//             <div className="flex items-center gap-1 bg-blue-50 border border-blue-200 rounded-lg px-2 py-1.5">
//               <button
//                 onClick={prevMonth}
//                 className="w-7 h-7 flex items-center justify-center rounded text-blue-500 hover:bg-blue-100 transition"
//               >
//                 <RiArrowLeftSLine className="w-4 h-4" />
//               </button>
//               <span className="text-sm font-semibold text-blue-700 px-2 min-w-[130px] text-center">
//                 {MONTH_NAMES[month - 1]} {year}
//               </span>
//               <button
//                 onClick={nextMonth}
//                 disabled={isCurrentMonth}
//                 className="w-7 h-7 flex items-center justify-center rounded text-blue-500 hover:bg-blue-100 transition disabled:opacity-30 disabled:cursor-not-allowed"
//               >
//                 <RiArrowRightSLine className="w-4 h-4" />
//               </button>
//             </div>

//             {!isCurrentMonth && (
//               <button
//                 onClick={() => {
//                   setYear(currentYear());
//                   setMonth(currentMonth());
//                 }}
//                 className="text-xs font-semibold text-blue-600 bg-blue-50 border border-blue-200 px-3 py-1.5 rounded-lg hover:bg-blue-100 transition"
//               >
//                 This Month
//               </button>
//             )}

//             <button
//               onClick={() => fetchMonthly(year, month)}
//               disabled={loading}
//               className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
//             >
//               <RiRefreshLine
//                 className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
//               />
//             </button>
//           </div>
//         </div>
//       </header>

//       <div className="w-full px-6 pt-6 pb-10">
//         {error && (
//           <div className="mb-4 flex items-center gap-2 px-4 py-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm">
//             <RiErrorWarningLine className="w-4 h-4 flex-shrink-0" /> {error}
//           </div>
//         )}

//         {metadata && (
//           <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
//             <div>
//               <p className="text-sm font-semibold text-slate-700">
//                 {metadata.monthName} {metadata.year}
//               </p>
//               <p className="text-xs text-blue-400">
//                 {metadata.totalDays} days · {metadata.totalStaff} staff members
//               </p>
//             </div>

//             <div className="flex items-center gap-5">
//               {[
//                 { color: "bg-emerald-500", label: "Present (checked-out)" },
//                 { color: "bg-emerald-400", label: "Present (checked-in)" },
//                 { color: "bg-red-400", label: "Absent" },
//               ].map(({ color, label }) => (
//                 <div key={label} className="flex items-center gap-2">
//                   <span className={`w-4 h-4 rounded-sm ${color}`} />
//                   <span className="text-xs text-slate-500 font-medium">
//                     {label}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm">
//           {loading ? (
//             <div className="py-24 flex flex-col items-center gap-3 text-blue-400">
//               <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
//               <span className="text-sm">Loading monthly attendance…</span>
//             </div>
//           ) : staffAttendance.length === 0 ? (
//             <div className="py-24 flex flex-col items-center gap-3">
//               <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
//                 <RiTeamLine className="w-7 h-7 text-blue-300" />
//               </div>
//               <span className="text-sm text-slate-400">
//                 No attendance data found.
//               </span>
//             </div>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="w-full border-collapse">
//                 <thead>
//                   <tr className="border-b border-slate-200 bg-white">
//                     <th className="sticky left-0 z-20 bg-white px-5 py-4 text-left min-w-[260px] border-r border-slate-100">
//                       <span className="text-sm font-semibold text-slate-500">
//                         Staff
//                       </span>
//                     </th>
//                     {dayNumbers.map((d) => (
//                       <th
//                         key={d}
//                         className="px-1 py-4 text-center min-w-[40px]"
//                       >
//                         <span className="text-sm font-semibold text-slate-500">
//                           {String(d).padStart(2, "0")}
//                         </span>
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {staffAttendance.map((staff) => {
//                     // ✅ Build a day→status map from dailyAttendance
//                     // Each entry has { day, status } where status is dailySummary.status:
//                     // "completed" | "partial" | "absent"
//                     const dayMap = {};
//                     (staff.dailyAttendance || []).forEach((da) => {
//                       dayMap[da.day] = da.status;
//                     });

//                     // ✅ Use monthlySummary — daysPresent already includes partial days
//                     const summary = staff.monthlySummary || {};
//                     const presentDays = summary.daysPresent ?? 0;
//                     const workingDays = summary.totalWorkingDays ?? totalDays;

//                     // Compute attendance percentage
//                     const pct =
//                       workingDays > 0
//                         ? ((presentDays / workingDays) * 100).toFixed(2)
//                         : "0.00";

//                     const pColor = percentColor(pct);

//                     return (
//                       <tr
//                         key={staff.staffId}
//                         className="border-b border-slate-100 transition hover:bg-slate-50/60"
//                       >
//                         <td className="sticky left-0 z-10 bg-white px-5 py-4 border-r border-slate-100">
//                           <div className="flex items-center gap-3">
//                             {staff.profilePic ? (
//                               <img
//                                 src={staff.profilePic}
//                                 alt={staff.name}
//                                 className="w-10 h-10 rounded-full object-cover border border-slate-200 shadow-sm flex-shrink-0"
//                               />
//                             ) : (
//                               <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white text-sm font-bold shadow-sm shadow-blue-200 flex-shrink-0">
//                                 {(staff.name || "?")[0].toUpperCase()}
//                               </div>
//                             )}
//                             <div className="min-w-0 flex-1">
//                               <p className="text-sm font-semibold text-slate-800 truncate">
//                                 {staff.name}
//                               </p>
//                               <p className="text-xs text-slate-400 truncate">
//                                 {staff.position}
//                               </p>
//                             </div>

//                             <div className="flex-shrink-0 flex items-center gap-1.5">
//                               <span
//                                 className={`inline-flex items-center px-2.5 py-1 rounded-lg border text-xs font-bold whitespace-nowrap ${pColor}`}
//                               >
//                                 {pct}%
//                               </span>
//                               {/* ✅ Show present days / total working days */}
//                               <span className="text-xs font-semibold text-slate-800 whitespace-nowrap">
//                                 {presentDays}
//                                 <span className="mx-0.5">/</span>
//                                 {workingDays}
//                               </span>
//                             </div>
//                           </div>
//                         </td>

//                         {dayNumbers.map((d) => {
//                           // ✅ Default to "absent" if no record; map to correct color
//                           const status = dayMap[d] || "absent";
//                           const sq =
//                             STATUS_SQUARE[status] || STATUS_SQUARE.absent;
//                           return (
//                             <td key={d} className="px-1 py-4 text-center">
//                               <span
//                                 className={`inline-block w-5 h-5 rounded-sm ${sq}`}
//                                 title={`Day ${d}: ${status}`}
//                               />
//                             </td>
//                           );
//                         })}
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import {
  RiCalendarLine,
  RiRefreshLine,
  RiTeamLine,
  RiArrowLeftSLine,
  RiArrowRightSLine,
  RiErrorWarningLine,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const ATTENDANCE_URL = `${process.env.REACT_APP_API_URL}/attendance`;
// ✅ Holiday routes are mounted separately (createHoliday/getAllHolidays/etc.)
// Update this base path if your holiday router is mounted under a different prefix.
const HOLIDAY_URL = `${process.env.REACT_APP_API_URL}/holiday`;

const currentYear = () => new Date().getFullYear();
const currentMonth = () => new Date().getMonth() + 1;

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// ✅ "completed" = approved + checked-out = Present
// "partial"   = approved but still checked-in = also Present (approved = present)
// "absent"    = no approved entry
// "holiday"   = official holiday (marked by backend) = shown grey with an "X"
const STATUS_SQUARE = {
  completed: "bg-emerald-500",
  partial: "bg-emerald-400", // approved = present, slightly lighter to distinguish
  absent: "bg-red-400",
  holiday: "bg-slate-400", // official holiday
};

const percentColor = (pct) => {
  const n = parseFloat(pct);
  if (n >= 85) return "text-emerald-600 border-emerald-400 bg-emerald-50";
  if (n >= 60) return "text-amber-600 border-amber-400 bg-amber-50";
  return "text-red-500 border-red-400 bg-red-50";
};

export default function AllAttendance() {
  const [year, setYear] = useState(currentYear());
  const [month, setMonth] = useState(currentMonth());
  const [metadata, setMetadata] = useState(null);
  const [staffAttendance, setStaffAttendance] = useState([]);
  const [holidays, setHolidays] = useState([]); // raw list from GET /get
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const isCurrentMonth = year === currentYear() && month === currentMonth();

  const fetchMonthly = async (y, m) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(
        `${ATTENDANCE_URL}/monthly-attendance/${y}/${m}`,
      );
      const data = res.data;
      setMetadata(data.metadata || null);
      setStaffAttendance(data.staffAttendance || []);
    } catch {
      setError("Failed to fetch monthly attendance.");
      setStaffAttendance([]);
      setMetadata(null);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Fetch all holidays once — cheap list, filtered client-side per month below
  const fetchHolidays = async () => {
    try {
      const res = await axios.get(`${HOLIDAY_URL}/get`);
      setHolidays(res.data?.data || []);
    } catch {
      // Non-blocking — attendance grid still works without holiday overlay
      setHolidays([]);
    }
  };

  useEffect(() => {
    fetchMonthly(year, month);
  }, [year, month]);

  useEffect(() => {
    fetchHolidays();
  }, []);

  // ✅ day-of-month → holidayName, scoped to the currently viewed year/month
  const holidayMap = useMemo(() => {
    const map = {};
    holidays.forEach((h) => {
      const d = new Date(h.date);
      if (d.getFullYear() === year && d.getMonth() + 1 === month) {
        map[d.getDate()] = h.holidayName;
      }
    });
    return map;
  }, [holidays, year, month]);

  const prevMonth = () => {
    if (month === 1) {
      setYear((y) => y - 1);
      setMonth(12);
    } else setMonth((m) => m - 1);
  };

  const nextMonth = () => {
    const now = new Date();
    if (
      year > now.getFullYear() ||
      (year === now.getFullYear() && month >= now.getMonth() + 1)
    )
      return;
    if (month === 12) {
      setYear((y) => y + 1);
      setMonth(1);
    } else setMonth((m) => m + 1);
  };

  const totalDays = metadata?.totalDays || new Date(year, month, 0).getDate();
  const dayNumbers = Array.from({ length: totalDays }, (_, i) => i + 1);

  return (
    <div className="min-h-screen bg-white text-slate-800">
      <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
              <RiCalendarLine className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-blue-800 tracking-tight">
                Monthly Attendance
              </h1>
              <p className="text-[11px] text-blue-400 tracking-widest uppercase">
                Staff Attendance Overview
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1 bg-blue-50 border border-blue-200 rounded-lg px-2 py-1.5">
              <button
                onClick={prevMonth}
                className="w-7 h-7 flex items-center justify-center rounded text-blue-500 hover:bg-blue-100 transition"
              >
                <RiArrowLeftSLine className="w-4 h-4" />
              </button>
              <span className="text-sm font-semibold text-blue-700 px-2 min-w-[130px] text-center">
                {MONTH_NAMES[month - 1]} {year}
              </span>
              <button
                onClick={nextMonth}
                disabled={isCurrentMonth}
                className="w-7 h-7 flex items-center justify-center rounded text-blue-500 hover:bg-blue-100 transition disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <RiArrowRightSLine className="w-4 h-4" />
              </button>
            </div>

            {!isCurrentMonth && (
              <button
                onClick={() => {
                  setYear(currentYear());
                  setMonth(currentMonth());
                }}
                className="text-xs font-semibold text-blue-600 bg-blue-50 border border-blue-200 px-3 py-1.5 rounded-lg hover:bg-blue-100 transition"
              >
                This Month
              </button>
            )}

            <button
              onClick={() => fetchMonthly(year, month)}
              disabled={loading}
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
            >
              <RiRefreshLine
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
            </button>
          </div>
        </div>
      </header>

      <div className="w-full px-6 pt-6 pb-10">
        {error && (
          <div className="mb-4 flex items-center gap-2 px-4 py-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm">
            <RiErrorWarningLine className="w-4 h-4 flex-shrink-0" /> {error}
          </div>
        )}

        {metadata && (
          <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
            <div>
              <p className="text-sm font-semibold text-slate-700">
                {metadata.monthName} {metadata.year}
              </p>
              <p className="text-xs text-blue-400">
                {metadata.totalDays} days · {metadata.totalStaff} staff members
              </p>
            </div>

            <div className="flex items-center gap-5">
              {[
                { color: "bg-emerald-500", label: "Present (checked-out)" },
                { color: "bg-emerald-400", label: "Present (checked-in)" },
                { color: "bg-red-400", label: "Absent" },
                { color: "bg-slate-400", label: "Official Holiday" },
              ].map(({ color, label }) => (
                <div key={label} className="flex items-center gap-2">
                  <span className={`w-4 h-4 rounded-sm ${color}`} />
                  <span className="text-xs text-slate-500 font-medium">
                    {label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm">
          {loading ? (
            <div className="py-24 flex flex-col items-center gap-3 text-blue-400">
              <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
              <span className="text-sm">Loading monthly attendance…</span>
            </div>
          ) : staffAttendance.length === 0 ? (
            <div className="py-24 flex flex-col items-center gap-3">
              <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
                <RiTeamLine className="w-7 h-7 text-blue-300" />
              </div>
              <span className="text-sm text-slate-400">
                No attendance data found.
              </span>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b border-slate-200 bg-white">
                    <th className="sticky left-0 z-20 bg-white px-5 py-4 text-left min-w-[260px] border-r border-slate-100">
                      <span className="text-sm font-semibold text-slate-500">
                        Staff
                      </span>
                    </th>
                    {dayNumbers.map((d) => (
                      <th
                        key={d}
                        className="px-1 py-4 text-center min-w-[40px]"
                      >
                        <span className="text-sm font-semibold text-slate-500">
                          {String(d).padStart(2, "0")}
                        </span>
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {staffAttendance.map((staff) => {
                    // ✅ Build a day→status map from dailyAttendance
                    // Each entry has { day, status } where status is dailySummary.status:
                    // "completed" | "partial" | "absent" | "holiday"
                    const dayMap = {};
                    (staff.dailyAttendance || []).forEach((da) => {
                      dayMap[da.day] = da.status;
                    });

                    // ✅ Use monthlySummary — daysPresent already includes partial days
                    const summary = staff.monthlySummary || {};
                    const presentDays = summary.daysPresent ?? 0;
                    // ✅ Holidays (from the Holiday collection) shouldn't count
                    // against working days when computing %
                    const holidayCount = Object.keys(holidayMap).length;
                    const workingDays =
                      (summary.totalWorkingDays ?? totalDays) - holidayCount;

                    // Compute attendance percentage
                    const pct =
                      workingDays > 0
                        ? ((presentDays / workingDays) * 100).toFixed(2)
                        : "0.00";

                    const pColor = percentColor(pct);

                    return (
                      <tr
                        key={staff.staffId}
                        className="border-b border-slate-100 transition hover:bg-slate-50/60"
                      >
                        <td className="sticky left-0 z-10 bg-white px-5 py-4 border-r border-slate-100">
                          <div className="flex items-center gap-3">
                            {staff.profilePic ? (
                              <img
                                src={staff.profilePic}
                                alt={staff.name}
                                className="w-10 h-10 rounded-full object-cover border border-slate-200 shadow-sm flex-shrink-0"
                              />
                            ) : (
                              <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white text-sm font-bold shadow-sm shadow-blue-200 flex-shrink-0">
                                {(staff.name || "?")[0].toUpperCase()}
                              </div>
                            )}
                            <div className="min-w-0 flex-1">
                              <p className="text-sm font-semibold text-slate-800 truncate">
                                {staff.name}
                              </p>
                              <p className="text-xs text-slate-400 truncate">
                                {staff.position}
                              </p>
                            </div>

                            <div className="flex-shrink-0 flex items-center gap-1.5">
                              <span
                                className={`inline-flex items-center px-2.5 py-1 rounded-lg border text-xs font-bold whitespace-nowrap ${pColor}`}
                              >
                                {pct}%
                              </span>
                              {/* ✅ Show present days / total working days (holidays excluded) */}
                              <span className="text-xs font-semibold text-slate-800 whitespace-nowrap">
                                {presentDays}
                                <span className="mx-0.5">/</span>
                                {workingDays}
                              </span>
                            </div>
                          </div>
                        </td>

                        {dayNumbers.map((d) => {
                          // ✅ Holiday (from the Holiday collection) always wins,
                          // regardless of whatever the attendance API says for that day
                          const isHoliday =
                            Object.prototype.hasOwnProperty.call(holidayMap, d);
                          const status = isHoliday
                            ? "holiday"
                            : dayMap[d] || "absent";
                          const sq =
                            STATUS_SQUARE[status] || STATUS_SQUARE.absent;
                          const tooltip = isHoliday
                            ? `Day ${d}: Holiday — ${holidayMap[d]}`
                            : `Day ${d}: ${status}`;
                          return (
                            <td key={d} className="px-1 py-4 text-center">
                              <span
                                className={`inline-flex items-center justify-center w-5 h-5 rounded-sm ${sq}`}
                                title={tooltip}
                              >
                                {isHoliday && (
                                  <span className="text-white text-[10px] font-bold leading-none">
                                    ✕
                                  </span>
                                )}
                              </span>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
